import { Icon } from "components/common/Icon";
import { RepaymentDetails } from "components/common/RepaymentDetails";
import { displayOptionsSubHeading, getCheckBoxText } from "domain/appSummary";
import { SelectedTreatmentsDetails } from "domain/selectedTreatments";
import checkboxtickSVG from "../../assets/tick.svg";
import { EXTEND_TERM_CONFIRM_TEXT } from "components/ExtendRemainingTerm/ExtendTerm.const";
import { IndicativeCalculationBanner } from "components/common/IndicativeCalculationBanner";

type ExtendTermSummaryProps = {
  selectedTreatments: SelectedTreatmentsDetails;
};
export const ExtendTermSummary = ({
  selectedTreatments,
}: ExtendTermSummaryProps) => {
  const { repaymentOption } = selectedTreatments;
  return (
    <>
      {!!repaymentOption && (
        <>
          <div className="appHeader">
            {displayOptionsSubHeading(repaymentOption.optionType)}
          </div>
          <RepaymentDetails
            repaymentOption={repaymentOption}
            existingLoanDetails={selectedTreatments.existingLoanDetails!}
          />
          <div className="repayment-info">
            <span>{EXTEND_TERM_CONFIRM_TEXT}</span>
          </div>
          <IndicativeCalculationBanner />
          <div className="chk-box">
            <Icon
              icon={checkboxtickSVG}
              width={19}
              alt="Checkbox Tick Icon"
              title={getCheckBoxText(repaymentOption.optionType)}
            />
          </div>
        </>
      )}
    </>
  );
};
